import React from 'react';
import cx from 'classnames';
import ImageSelection from '../Global/ImageSelection/ImageSelection';

export default function MmcOptionsSection({
  hasOptions,
  hideOptions,
  isImageBased,
  isVerticalText,
  effectiveOptions,
  animatedOptions,
  selectedOption,
  highlightedOption,
  canSelectOption,
  isRepeating,
  onOptionSelect,
  onImageLoadError,
  onAllImagesFailed,
}) {
  if (!hasOptions) {
    return null;
  }

  return (
    <div className={cx('imageSelectionWrapper', { hidden: hideOptions })}>
      {isImageBased ? (
        <ImageSelection
          options={effectiveOptions}
          handleSelection={(key) => canSelectOption && !isRepeating && onOptionSelect(key)}
          useAnimation={true}
          animatedOptions={animatedOptions}
          selectedOption={selectedOption}
          highlightedOption={highlightedOption}
          useHover={canSelectOption && !isRepeating}
          onImageLoadError={onImageLoadError}
          onAllImagesFailed={onAllImagesFailed}
        />
      ) : isVerticalText ? (
        <div className="wordSelection">
          {effectiveOptions.map((option) => (
            <div
              className={cx('wordTile', {
                willAnimate: true,
                animate: animatedOptions.includes(option.key),
                selected: selectedOption === option.key,
                highlighted: highlightedOption === option.key,
                useHover: canSelectOption && !isRepeating,
              })}
              key={option.key}
              onClick={() => canSelectOption && !isRepeating && onOptionSelect(option.key)}
            >
              <span className="wordTile__label">{option.text}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="imageSelection">
          {effectiveOptions.map((option) => (
            <div
              className={cx('imageBox', {
                willAnimate: true,
                animate: animatedOptions.includes(option.key),
                selected: selectedOption === option.key,
                highlighted: highlightedOption === option.key,
                useHover: canSelectOption && !isRepeating,
              })}
              key={option.key}
              onClick={() => canSelectOption && !isRepeating && onOptionSelect(option.key)}
            >
              <div className="answerBox textAnswerBox">
                <span className="textAnswerLabel">{option.text || option.key}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
